import React from 'react';

const Donut = ({ className }: { className?: string }) => {
  return (
    <svg
      width="690"
      height="690"
      viewBox="0 0 690 690"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      preserveAspectRatio="xMidYMid meet"
      style={{ transform: 'translateZ(0)' }}
    >
      <g id="Group 2085664912">
        <g
          clipPath="url(#bgblur_0_5796_47841_clip_path)"
          filter="url(#softBlur)"
        >
          <rect
            x="-31.8186"
            y="-31.8186"
            width="753.637"
            height="753.637"
            fill="url(#paint0_linear_5796_47841)"
            opacity="0.5"
          />
        </g>

        <g id="Ellipse 22005" data-figma-bg-blur-radius="31.8186">
          <mask
            id="path-1-outside-1_5796_47841"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="690"
            height="690"
            fill="black"
          >
            <rect fill="white" width="690" height="690" />
            <path d="M689 345C689 534.986 534.986 689 345 689C155.014 689 1 534.986 1 345C1 155.014 155.014 1 345 1C534.986 1 689 155.014 689 345ZM25.08 345C25.08 521.687 168.313 664.92 345 664.92C521.687 664.92 664.92 521.687 664.92 345C664.92 168.313 521.687 25.08 345 25.08C168.313 25.08 25.08 168.313 25.08 345Z" />
          </mask>
          <path
            d="M689 345C689 534.986 534.986 689 345 689C155.014 689 1 534.986 1 345C1 155.014 155.014 1 345 1C534.986 1 689 155.014 689 345ZM25.08 345C25.08 521.687 168.313 664.92 345 664.92C521.687 664.92 664.92 521.687 664.92 345C664.92 168.313 521.687 25.08 345 25.08C168.313 25.08 25.08 168.313 25.08 345Z"
            fill="url(#paint0_linear_5796_47841)"
            fillOpacity="0.5"
            style={{ mixBlendMode: 'darken' }}
          />
          <path
            d="M689 345C689 534.986 534.986 689 345 689C155.014 689 1 534.986 1 345C1 155.014 155.014 1 345 1C534.986 1 689 155.014 689 345ZM25.08 345C25.08 521.687 168.313 664.92 345 664.92C521.687 664.92 664.92 521.687 664.92 345C664.92 168.313 521.687 25.08 345 25.08C168.313 25.08 25.08 168.313 25.08 345Z"
            stroke="url(#paint1_linear_5796_47841)"
            strokeOpacity="0.1"
            strokeWidth="2"
            style={{ mixBlendMode: 'overlay' }}
            mask="url(#path-1-outside-1_5796_47841)"
          />
        </g>

        <g id="Group 2085664911">
          <g
            clipPath="url(#bgblur_1_5796_47841_clip_path)"
            filter="url(#softBlur)"
          >
            <rect
              x="-31.8186"
              y="-31.8186"
              width="753.637"
              height="753.637"
              fill="url(#paint2_linear_5796_47841)"
              opacity="0.5"
            />
          </g>
          <g
            id="bitunix"
            opacity="0.2"
            data-figma-bg-blur-radius="31.8186"
            className="transition-opacity duration-500"
          >
            <path
              d="M345 5C345 4.44772 345.448 3.99985 346 4.00147C406.636 4.17932 466.134 20.5225 518.36 51.3549C570.872 82.357 614.111 126.874 643.57 180.267C673.029 233.661 687.632 293.977 685.855 354.933C684.079 415.888 665.989 475.252 633.471 526.84C600.952 578.427 555.195 620.35 500.966 648.242C446.737 676.133 386.021 688.972 325.143 685.421C264.265 681.87 205.453 662.059 154.835 628.052C104.493 594.23 64.0878 547.598 37.7765 492.969C37.5368 492.471 37.7476 491.874 38.2459 491.635L51.8243 485.145C52.3226 484.906 52.9197 485.118 53.1594 485.615C78.1557 537.494 116.532 581.778 164.343 613.899C212.43 646.206 268.302 665.027 326.136 668.4C383.969 671.774 441.65 659.577 493.168 633.08C544.685 606.583 588.155 566.756 619.047 517.748C649.94 468.74 667.125 412.344 668.812 354.436C670.5 296.529 656.628 239.228 628.642 188.504C600.655 137.78 559.579 95.4892 509.692 66.0372C460.092 36.7548 403.587 21.2294 346 21.0516C345.448 21.0499 345 20.6023 345 20.05V5Z"
              fill="url(#paint2_linear_5796_47841)"
              fillOpacity="0.5"
              style={{ mixBlendMode: 'darken' }}
            />
            <path
              d="M345 5C345 4.44772 345.448 3.99985 346 4.00147C406.636 4.17932 466.134 20.5225 518.36 51.3549C570.872 82.357 614.111 126.874 643.57 180.267C673.029 233.661 687.632 293.977 685.855 354.933C684.079 415.888 665.989 475.252 633.471 526.84C600.952 578.427 555.195 620.35 500.966 648.242C446.737 676.133 386.021 688.972 325.143 685.421C264.265 681.87 205.453 662.059 154.835 628.052C104.493 594.23 64.0878 547.598 37.7765 492.969C37.5368 492.471 37.7476 491.874 38.2459 491.635L51.8243 485.145C52.3226 484.906 52.9197 485.118 53.1594 485.615C78.1557 537.494 116.532 581.778 164.343 613.899C212.43 646.206 268.302 665.027 326.136 668.4C383.969 671.774 441.65 659.577 493.168 633.08C544.685 606.583 588.155 566.756 619.047 517.748C649.94 468.74 667.125 412.344 668.812 354.436C670.5 296.529 656.628 239.228 628.642 188.504C600.655 137.78 559.579 95.4892 509.692 66.0372C460.092 36.7548 403.587 21.2294 346 21.0516C345.448 21.0499 345 20.6023 345 20.05V5Z"
              fill="url(#paint3_linear_5796_47841)"
            />
          </g>

          <g
            clipPath="url(#bgblur_2_5796_47841_clip_path)"
            filter="url(#softBlur)"
          >
            <rect
              x="-31.8186"
              y="-31.8186"
              width="753.637"
              height="753.637"
              fill="url(#paint4_linear_5796_47841)"
              opacity="0.5"
            />
          </g>
          <g
            id="pionex"
            opacity="0.2"
            data-figma-bg-blur-radius="31.8186"
            className="transition-opacity duration-500"
          >
            <path
              d="M36.9505 488.894C36.4501 489.128 35.8545 488.911 35.6222 488.41C2.52082 417.001 -4.86281 336.328 14.7433 260.08C34.3493 183.831 79.7318 116.726 143.173 70.1418C143.619 69.8149 144.245 69.9123 144.571 70.3584L153.442 82.5153C153.768 82.9614 153.67 83.5874 153.224 83.9143C92.976 128.168 49.8777 191.906 31.2561 264.326C12.6345 336.745 19.6417 413.366 51.0701 481.194C51.3022 481.695 51.0866 482.291 50.5862 482.525L36.9505 488.894Z"
              fill="url(#paint4_linear_5796_47841)"
              fillOpacity="0.5"
              style={{ mixBlendMode: 'darken' }}
            />
            <path
              d="M36.9505 488.894C36.4501 489.128 35.8545 488.911 35.6222 488.41C2.52082 417.001 -4.86281 336.328 14.7433 260.08C34.3493 183.831 79.7318 116.726 143.173 70.1418C143.619 69.8149 144.245 69.9123 144.571 70.3584L153.442 82.5153C153.768 82.9614 153.67 83.5874 153.224 83.9143C92.976 128.168 49.8777 191.906 31.2561 264.326C12.6345 336.745 19.6417 413.366 51.0701 481.194C51.3022 481.695 51.0866 482.291 50.5862 482.525L36.9505 488.894Z"
              fill="url(#paint5_linear_5796_47841)"
            />
          </g>

          <g
            clipPath="url(#bgblur_4_5796_47841_clip_path)"
            filter="url(#softBlur)"
          >
            <rect
              x="-31.8186"
              y="-31.8186"
              width="753.637"
              height="753.637"
              fill="url(#paint8_linear_5796_47841)"
              opacity="0.5"
            />
          </g>
          <g
            id="phemex"
            opacity="0.2"
            data-figma-bg-blur-radius="31.8186"
            className="transition-opacity duration-500"
          >
            <path
              d="M147.019 68.5882C146.697 68.1392 146.801 67.5143 147.251 67.194C177.924 45.3599 212.002 28.7564 248.1 18.0575C248.63 17.9005 249.185 18.2043 249.341 18.7343L252.419 16.8084C281.354 8.64597 311.241 4.34588 341.304 4.02003C341.856 4.01404 342.308 4.45836 342.312 5.01063L342.431 20.0602C342.435 20.6124 341.991 21.0635 341.439 21.0696C312.913 21.3832 284.553 25.4634 257.096 33.2045C256.564 33.3543 256.011 33.0468 255.859 32.5157L252.897 34.4188C218.637 44.5786 186.294 60.3369 157.179 81.0553C156.729 81.3755 156.104 81.2725 155.783 80.8235L147.019 68.5882Z"
              fill="url(#paint8_linear_5796_47841)"
              fillOpacity="0.5"
              style={{ mixBlendMode: 'darken' }}
            />
            <path
              d="M147.019 68.5882C146.697 68.1392 146.801 67.5143 147.251 67.194C177.924 45.3599 212.002 28.7564 248.1 18.0575C248.63 17.9005 249.185 18.2043 249.341 18.7343L252.419 16.8084C281.354 8.64597 311.241 4.34588 341.304 4.02003C341.856 4.01404 342.308 4.45836 342.312 5.01063L342.431 20.0602C342.435 20.6124 341.991 21.0635 341.439 21.0696C312.913 21.3832 284.553 25.4634 257.096 33.2045C256.564 33.3543 256.011 33.0468 255.859 32.5157L252.897 34.4188C218.637 44.5786 186.294 60.3369 157.179 81.0553C156.729 81.3755 156.104 81.2725 155.783 80.8235L147.019 68.5882Z"
              fill="url(#paint9_linear_5796_47841)"
            />
          </g>
        </g>
      </g>

      <defs>
        <filter
          id="softBlur"
          x="-200%"
          y="-200%"
          width="400%"
          height="400%"
          filterUnits="objectBoundingBox"
        >
          <feGaussianBlur stdDeviation="8" edgeMode="duplicate" />
        </filter>

        <clipPath
          id="bgblur_0_5796_47841_clip_path"
          clipPathUnits="userSpaceOnUse"
        >
          <g transform="translate(31.8186 31.8186)">
            <path d="M689 345C689 534.986 534.986 689 345 689C155.014 689 1 534.986 1 345C1 155.014 155.014 1 345 1C534.986 1 689 155.014 689 345ZM25.08 345C25.08 521.687 168.313 664.92 345 664.92C521.687 664.92 664.92 521.687 664.92 345C664.92 168.313 521.687 25.08 345 25.08C168.313 25.08 25.08 168.313 25.08 345Z" />
          </g>
        </clipPath>
        <clipPath
          id="bgblur_1_5796_47841_clip_path"
          clipPathUnits="userSpaceOnUse"
        >
          <g transform="translate(31.8186 31.8186)">
            <path d="M345 5C345 4.44772 345.448 3.99985 346 4.00147C406.636 4.17932 466.134 20.5225 518.36 51.3549C570.872 82.357 614.111 126.874 643.57 180.267C673.029 233.661 687.632 293.977 685.855 354.933C684.079 415.888 665.989 475.252 633.471 526.84C600.952 578.427 555.195 620.35 500.966 648.242C446.737 676.133 386.021 688.972 325.143 685.421C264.265 681.87 205.453 662.059 154.835 628.052C104.493 594.23 64.0878 547.598 37.7765 492.969C37.5368 492.471 37.7476 491.874 38.2459 491.635L51.8243 485.145C52.3226 484.906 52.9197 485.118 53.1594 485.615C78.1557 537.494 116.532 581.778 164.343 613.899C212.43 646.206 268.302 665.027 326.136 668.4C383.969 671.774 441.65 659.577 493.168 633.08C544.685 606.583 588.155 566.756 619.047 517.748C649.94 468.74 667.125 412.344 668.812 354.436C670.5 296.529 656.628 239.228 628.642 188.504C600.655 137.78 559.579 95.4892 509.692 66.0372C460.092 36.7548 403.587 21.2294 346 21.0516C345.448 21.0499 345 20.6023 345 20.05V5Z" />
          </g>
        </clipPath>
        <clipPath
          id="bgblur_2_5796_47841_clip_path"
          clipPathUnits="userSpaceOnUse"
        >
          <g transform="translate(31.8186 31.8186)">
            <path d="M36.9505 488.894C36.4501 489.128 35.8545 488.911 35.6222 488.41C2.52082 417.001 -4.86281 336.328 14.7433 260.08C34.3493 183.831 79.7318 116.726 143.173 70.1418C143.619 69.8149 144.245 69.9123 144.571 70.3584L153.442 82.5153C153.768 82.9614 153.67 83.5874 153.224 83.9143C92.976 128.168 49.8777 191.906 31.2561 264.326C12.6345 336.745 19.6417 413.366 51.0701 481.194C51.3022 481.695 51.0866 482.291 50.5862 482.525L36.9505 488.894Z" />
          </g>
        </clipPath>
        <clipPath
          id="bgblur_4_5796_47841_clip_path"
          clipPathUnits="userSpaceOnUse"
        >
          <g transform="translate(31.8186 31.8186)">
            <path d="M147.019 68.5882C146.697 68.1392 146.801 67.5143 147.251 67.194C177.924 45.3599 212.002 28.7564 248.1 18.0575C248.63 17.9005 249.185 18.2043 249.341 18.7343L252.419 16.8084C281.354 8.64597 311.241 4.34588 341.304 4.02003C341.856 4.01404 342.308 4.45836 342.312 5.01063L342.431 20.0602C342.435 20.6124 341.991 21.0635 341.439 21.0696C312.913 21.3832 284.553 25.4634 257.096 33.2045C256.564 33.3543 256.011 33.0468 255.859 32.5157L252.897 34.4188C218.637 44.5786 186.294 60.3369 157.179 81.0553C156.729 81.3755 156.104 81.2725 155.783 80.8235L147.019 68.5882Z" />
          </g>
        </clipPath>

        <linearGradient
          id="paint0_linear_5796_47841"
          x1="1484.86"
          y1="-815.271"
          x2="138.631"
          y2="1791.77"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopOpacity="0" />
          <stop offset="0.5" />
          <stop offset="1" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_5796_47841"
          x1="521"
          y1="113.16"
          x2="171.72"
          y2="113.16"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="0.5" stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_5796_47841"
          x1="1474.92"
          y1="-805.153"
          x2="140.43"
          y2="1779.16"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopOpacity="0" />
          <stop offset="0.5" />
          <stop offset="1" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_5796_47841"
          x1="4"
          y1="-1094.48"
          x2="4"
          y2="513.053"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.576923" stopColor="#ABF364" />
          <stop offset="1" stopColor="#D9F9B9" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_5796_47841"
          x1="1474.92"
          y1="-805.153"
          x2="140.43"
          y2="1779.16"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopOpacity="0" />
          <stop offset="0.5" />
          <stop offset="1" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_5796_47841"
          x1="89.4996"
          y1="193.962"
          x2="33.9997"
          y2="686"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.576923" stopColor="#FF8D28" />
          <stop offset="1" stopColor="#FFB069" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_5796_47841"
          x1="1474.92"
          y1="-805.153"
          x2="140.43"
          y2="1779.16"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopOpacity="0" />
          <stop offset="0.5" />
          <stop offset="1" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_5796_47841"
          x1="315"
          y1="-21"
          x2="215"
          y2="63.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0B5BE0" />
          <stop offset="1" stopColor="#0B5BE0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default Donut;
